import React, { useState } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const Loader = () => {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(!open);

  return (
    <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={open} onClick={handleClose}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Loader;
